import React from 'react';
import MainMenu from 'components/common/mainmenu';
import ComparisonCard from 'components/pages/comparison/comparisoncard';
import Charts from 'components/pages/comparison/charts';
import StickyMenu from "components/common/stickymenu"
export default class Comparison extends React.Component {

    render() {
        return (
            <div className="comparison-page">
                <StickyMenu
                    withStickyHeader={true}
                >
                    <MainMenu
                        overviewIsActive={false}
                        comparisonIsActive={true}
                        onlyLeftMenu={false}
                    />
                </StickyMenu>
                <div className="page-content">
                    <ComparisonCard />
                    <Charts />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/comparison/index.jsx